import * as PropTypes from 'prop-types';
import * as React from 'react';
import ScrollTarget from '../../shared/scroll_target';
import SearchPills from './search_pills/search_pills';
import LoadingOverlay from '../../shared/loading_overlay';
import IndexSidebar from './index_sidebar';
import ListingCardWide from './listing_card_wide';
import Pagination from '../../shared/pagination';
import Error from './error';
import EmptySearch from './empty_search';
import Filtering from './filtering';
import Trait from '../../taxonomy/trait';

const operatingSystem = Trait.findByUuid('c6639f61-8884-45e2-9f78-9f1de059700b');
const fileType = Trait.findByUuid('2ae386f1-7144-4d0c-b8aa-6caba14faa6f');

class DigitalListings extends React.Component {
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.scrollToTop) {
      this.refs.scrollTarget.scrollToTop();
    }
  }

  get showOverlay() {
    return this.props.loading && this.props.digitalListings.length;
  }

  renderListingsCount() {
    if (!this.props.initialLoadComplete) { return false; }

    return (
      <p className="search-context-query strong">
        {I18n.t('digitalProductsIndex.resultsCount', { count: this.props.totalCount })}
      </p>
    );
  }

  renderPagination() {
    if (this.props.pagination) {
      return (
        <Pagination
          changePage={page => this.props.indexParams.changePage(page)}
          totalPages={this.props.pagination.totalPages}
          currentPage={this.props.pagination.currentPage}
        />
      );
    }

    return null;
  }

  renderDigitalListings() {
    if (!this.props.initialLoadComplete) { return false; }
    if (this.props.error) { return <Error />; }
    if (this.props.digitalListings.length === 0) { return <EmptySearch />; }

    return (
      <div>
        <Filtering sort={this.props.sort} indexParams={this.props.indexParams} />
        <ul>
          {
            this.props.digitalListings.map((listing, index) =>
              (<ListingCardWide
                key={index}
                listing={listing}
              />))
          }
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div className="digital-listing-page">
        <div className="site-wrapper">
          <section className="mt-2 search-context-bar pb-half mb-1">
            <ScrollTarget ref="scrollTarget" onlyScrollUp />
            <div>
              {this.renderListingsCount()}
              <SearchPills
                operatingSystem={operatingSystem}
                indexParams={this.props.indexParams}
                category={this.props.category}
                fileType={fileType}
              />
            </div>
          </section>
        </div>
        <LoadingOverlay showOverlay={this.showOverlay}>
          <section className="faceted-grid">
            <div className="faceted-grid__inner">
              <div className="faceted-grid__facets">
                <IndexSidebar
                  indexParams={this.props.indexParams}
                  facets={this.props.facets}
                />
              </div>
              <div className="faceted-grid__main">
                {this.renderDigitalListings()}
                <section className="margined-top margined-bottom clearfix">
                  {this.renderPagination()}
                </section>
              </div>
            </div>
          </section>
        </LoadingOverlay>
      </div>
    );
  }
}

DigitalListings.propTypes = {
  indexParams: PropTypes.object.isRequired,
  initialLoadComplete: PropTypes.bool,
  totalCount: PropTypes.number,
  loading: PropTypes.bool,
  digitalListings: PropTypes.array,
  facets: PropTypes.object,
  sort: PropTypes.string,
  error: PropTypes.bool,
  pagination: PropTypes.object,
  category: PropTypes.object,
};

export default DigitalListings;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/index_page/digital_listings.jsx